import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventStoreService } from 'src/app/services/stores/event.store.service';

@Component({
  selector: 'app-kiosk',
  templateUrl: './kiosk.component.html',
  styleUrl: './kiosk.component.scss',
  standalone: false,
  providers: [EventStoreService],
})
export class KioskComponent implements OnInit {
  private route: ActivatedRoute = inject(ActivatedRoute);
  eventStoreService = inject(EventStoreService);

  constructor() {
    this.route.paramMap.subscribe((paramsMap) => {
      const eventId = paramsMap.get('eventId');
      if (eventId && eventId !== this.eventStoreService.event()?.id) {
        this.eventStoreService.getById(eventId);
      }
    });
  }

  ngOnInit(): void {
    history.pushState(null, '', location.href);
    window.onpopstate = function () {
      history.go(1); // pushes them forward one step, back to the current page
    };
  }
}
